export default __webpack_public_path__ + "static/11008-182347ec94f9060596d99601dcd5998b.jpg";